export default __webpack_public_path__ + "static/client-logos-d347149388a1d9b32d999486bf203f24.jpeg";